import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  Navbar,
  NavbarToggler,
  Collapse,
  Nav,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";

import logo from "../../../assets/images/logo.svg";
import "./Header.scss";
import { Link as ReactLink } from "react-router-dom";

const Link = ({to, matches, children}) => {
  const pathname = window.location.pathname;
  return (
    <ReactLink to={to} className={matches.includes(pathname) ? "active" : ""}>
      <span className="secondary">
        {children}
      </span>
    </ReactLink>
  );
};

const Header = ({ page }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [collapse, setCollapse] = useState(false);
  const pathname = window.location.pathname;

  const vehiclesActiveTabs = [
    "vehicles",
    "compare",
    "tabbed-maps-dealer-catalog-tab",
  ];

  useEffect(() => {
    if (pathname !== "/") {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [pathname]);

  return (
    <header className="headerWrapper">
      <div className="Header">
        <div className="container" style={{ padding: 0, maxWidth: "1224px" }}>
          <Navbar expand="lg">
            <div style={{ paddingTop: "0.75rem", paddingBottom: "0.75rem" }}>
              <a
                href="https://dasher.doordash.com/?utm_source=zappy"
                target="_blank"
                rel="noopener noreferrer"
                className="navbar-brand"
              >
                <img src={logo} alt="DoorDash" />
              </a>
            </div>

            <NavbarToggler onClick={() => setCollapse(!collapse)} />
            <Collapse isOpen={collapse} navbar>
              <Nav className="ml-auto" navbar>
                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle
                    nav
                    caret
                    className={
                      vehiclesActiveTabs.includes(page) ? "active" : ""
                    }
                  >
                    <span>Earning</span>
                  </DropdownToggle>

                  <DropdownMenu left>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/about/pay"
                    >
                      Pay
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/about/perks"
                    >
                      Perks
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/about/discounts"
                    >
                      Discounts
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/about/dasherdirect"
                    >
                      DasherDirect
                    </a>
                  </DropdownMenu>
                </UncontrolledDropdown>

                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle
                    nav
                    caret
                    className={
                      vehiclesActiveTabs.includes(page) ? "active" : ""
                    }
                  >
                    <span>Ways to Dash</span>
                  </DropdownToggle>

                  <DropdownMenu left>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/about/shop-and-deliver"
                    >
                      {"Shop & Deliver"}
                    </a>
                  </DropdownMenu>
                </UncontrolledDropdown>

                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle
                    nav
                    caret
                    className={
                      vehiclesActiveTabs.includes(page) ? "active" : ""
                    }
                  >
                    <span>Community</span>
                  </DropdownToggle>

                  <DropdownMenu left>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/blog/category/spotlights"
                    >
                      Dasher Spotlights
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/community/beyond-the-dash"
                    >
                      Beyond the Dash
                    </a>
                  </DropdownMenu>
                </UncontrolledDropdown>

                <UncontrolledDropdown nav inNavbar>
                  <DropdownToggle
                    nav
                    caret
                    className={
                      vehiclesActiveTabs.includes(page) ? "active" : ""
                    }
                  >
                    <span>Resources</span>
                  </DropdownToggle>

                  <DropdownMenu left>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/blog"
                    >
                      Blog
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/covid-updates"
                    >
                      COVID-19
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://help.doordash.com/dashers/s/?language=en_US&_ga=2.34092967.743240585.1662491068-2084572770.1661538376"
                    >
                      Support
                    </a>
                    <a
                      target="_blank"
                      rel="noopener noreferrer"
                      className="dropdown-item"
                      href="https://dasher.doordash.com/en-us/faq"
                    >
                      FAQ
                    </a>
                  </DropdownMenu>
                </UncontrolledDropdown>
              </Nav>
            </Collapse>

            <div className="rightControl">
              <a
                target="_blank"
                rel="noopener noreferrer"
                className="login-item"
                href="https://identity.doordash.com/auth?client_id=1699031494479676248&redirect_uri=https%3A%2F%2Fmerchant-portal.doordash.com%2Fdasher_auth_callback&response_type=code&scope=*&prompt=none&login_user=&device_id=&layout=dasher_web&_ga=2.25246651.743240585.1662491068-2084572770.1661538376&state=3e1bfbd0-34f4-4bb4-916d-d3960a2eb751&allowRedirect=true&failureRedirect=%2Fdasher%2Flogin&successRedirect=https%3A%2F%2Fwww.doordash.com%2Fdasher%2Fapplication&passReqToCallback=true"
              >
                Login
              </a>
              <a
                className="btn"
                href="https://dasher.doordash.com/?utm_source=zappy"
                target="_blank"
                rel="noopener noreferrer"
              >
                Sign Up
              </a>
            </div>
          </Navbar>
        </div>
      </div>
      <div className="subHeader" style={{ display: isOpen ? "flex" : "none" }}>
        <svg
          width="135"
          height="38"
          viewBox="0 0 135 38"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0 6C0 2.68629 2.68629 0 6 0H122.5L134.5 19L122.5 38H6C2.68629 38 0 35.3137 0 32V6Z"
            fill="#EB1700"
          />
        </svg>
        <a
          style={{ zIndex: 1 }}
          href="https://dasher.doordash.com/en-us/about/electric-vehicles?utm_source=zappy"
        >
          <p>Electric Vehicles</p>
        </a>
        <Link to="/used-vehicles" matches={['/vehicles', '/used-vehicles']}>
          Browse All EVs
        </Link>
        <Link to="/compare-vehicles-used" matches={["/compare-vehicles", "/compare-vehicles-used"]}>
          Compare Vehicles
        </Link>
        <Link to="/charging-stations" matches={["/charging-stations"]}>
          Find Charging Stations
        </Link>
        <Link to="/incentives" matches={["/incentives"]}>
          Discover Incentives
        </Link>
      </div>
    </header>
  );
};

export default Header;

Header.propTypes = {
  page: PropTypes.string,
};
